import React from 'react'
import './stylesheet/horizontalrule.css'
export const HorizontalRule = () => {
    return (
        <>
            <div className="hr_sect">OR</div>
        </>
    )
}
